import React, { useEffect, useMemo, useState } from "react";
import { GetAllWEBFAQforWeb } from "../../APIs/APIHelperforWeb";
import Faqs2 from "./Faqs2";

export default function Faqs({ onHomePage = false }) {
  const [allFaqRows, setAllFaqRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadFaqs = async () => {
      setIsLoading(true);
      const rows = await GetAllWEBFAQforWeb();
      const activeRows = Array.isArray(rows)
        ? rows.filter((item) => item?.IsActive !== false)
        : [];
      setAllFaqRows(activeRows);
      setIsLoading(false);
    };

    loadFaqs();
  }, []);

  const groupedFaqs = useMemo(() => {
    const sortedFaqs = [...allFaqRows].sort((a, b) => {
      const typeDiff = Number(a?.TypeId || 0) - Number(b?.TypeId || 0);
      if (typeDiff !== 0) {
        return typeDiff;
      }
      return Number(a?.Id || 0) - Number(b?.Id || 0);
    });

    const groupedMap = new Map();
    sortedFaqs.forEach((item) => {
      const typeId = Number(item?.TypeId || 0);
      const typeName = (item?.TypeName || "Frequently Asked Questions").trim();
      const groupKey = `${typeId}__${typeName.toLowerCase().replace(/\s+/g, "-")}`;

      if (!groupedMap.has(groupKey)) {
        groupedMap.set(groupKey, {
          groupKey,
          typeId,
          typeName,
          items: [],
        });
      }

      groupedMap.get(groupKey).items.push(item);
    });

    return Array.from(groupedMap.values()).sort((a, b) => a.typeId - b.typeId);
  }, [allFaqRows]);

  return (
    <section className="flat-section" style={onHomePage ? { marginTop: "0px", paddingTop: "0px" } : {}} >
      <div className="container">
        {
          onHomePage && (
            <div className="box-title text-center wow fadeInUp">
              <div className="text-subtitle text-primary">FAQs</div>
              <h3 className="title mt-4">Frequent Asked Questions</h3>
            </div>
          )
        }
        {isLoading ? (
          <div className="tf-faq">
            <h5 className="mb-16 text-black-2">Loading FAQs...</h5>
          </div>
        ) : groupedFaqs.length > 0 ? (
          groupedFaqs.map((group) => (
            <Faqs2
              key={group.groupKey}
              faqTitle={group.typeName}
              allFaqs={group.items}
              groupKey={group.groupKey}
              onHomePage={true}
            />
          ))
        ) : (
          <div className="tf-faq">
            <h5 className="mb-16 text-black-2">No FAQs found.</h5>
          </div>
        )}
      </div>
    </section>
  );
}
